import {EmojiDict} from "../../../../gd/const/item-icon/emoji/emoji";
import React from "react";

type Props = {
    name        : string      // this is our system name (config)
    className?  : string
    size        : string        // size in pixels
}

export default function Emoji(props:Props) {

    const classes = Classes("ui5-emoji", props.className)

    return (
        <div className={classes} style={{fontSize: props.size+'px', width: props.size + "px", lineHeight: props.size + "px"}}>
            {EmojiDict[props.name].symbol}
        </div>
    )

}